import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { PanelLeft, PanelLeftOpen } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function FloatingSidebarTrigger() {
  const { state } = useSidebar(); // 'expanded' | 'collapsed' | 'hover' | ...
  const { t } = useTranslation();
  // tweak these to match your sidebar widths (px)
  const leftPx = state === "collapsed" ? 10 : 260;
  const isCollapsed = state === "collapsed";
  const tooltipLabel = isCollapsed
    ? t("sidebar.open", { defaultValue: "Ouvrir la sidebar" })
    : t("sidebar.close", { defaultValue: "Fermer la sidebar" });

  return (
    <TooltipProvider delayDuration={120} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="fixed top-0.5 z-50 group transition-[left] duration-200 ease-out"
            style={{ left: leftPx }}
          >
            <SidebarTrigger
              aria-label={tooltipLabel}
              className="relative h-7 w-7 transition-all pointer-events-auto text-slate-400/90 hover:text-slate-600 hover:bg-white/80 cursor-ew-resize"
              icon={
                isCollapsed ? (
                  <PanelLeftOpen className="h-4 w-4" strokeWidth={1.5} />
                ) : (
                  <PanelLeft className="h-4 w-4" strokeWidth={1.5} />
                )
              }
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-[11px] px-2 py-1">
          {tooltipLabel}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
